/* eslint-disable arrow-parens */
import ApiClient from 'src/api_clients/ChemotionApiClient';
import DocumentHelper from 'src/utilities/DocumentHelper';

class ResponseError extends Error {
  constructor(response) {
    super(`${response.status} ${response.statusText}`);
    this.status = response.status;
    this.response = response;
  }

  json() {
    return this.response.json();
  }
}

// TODO: SamplesFetcher also updates Samples and so on...naming?
export default class UsersFetcher {
  static fetchElementKlasses(genericOnly = true) {
    let api = '/api/v1/generic_elements/klasses';
    if (genericOnly) {
      api = '/api/v1/generic_elements/klasses?generic_only=true';
    }
    return ApiClient.getJson(api);
  }

  static fetchElementKlassNames(genericOnly = true) {
    let api = '/api/v1/labimotion_hub/element_klasses_name';
    if (genericOnly) {
      api = '/api/v1/labimotion_hub/element_klasses_name?generic_only=true';
    }

    return ApiClient.getJson(api);
  }

  static fetchOmniauthProviders() {
    return ApiClient.getJson('/api/v1/public/omniauth_providers');
  }

  static fetchDeviseMappings() {
    return ApiClient.getJson('/api/v1/public/devise_mappings');
  }

  static fetchUsersByName(name, type = 'Person') {
    return ApiClient.getJson(`/api/v1/users/name?${new URLSearchParams({ name, type })}`);
  }

  static fetchCurrentUser() {
    return ApiClient.getJson('/api/v1/users/current');
  }

  static fetchProfile() {
    return ApiClient.getJson('/api/v1/profiles');
  }

  static updateUserProfile(params = {}) {
    return ApiClient.putJson('/api/v1/profiles', { body: params });
  }

  static fetchNoVNCDevices(id = 0) {
    return ApiClient.getJson(`/api/v1/devices/novnc?id=${id}`)
      .then((json) => json.devices);
  }

  static createGroup(params = {}) {
    return ApiClient.postJson('/api/v1/groups', { body: params });
  }

  static fetchCurrentGroups() {
    return ApiClient.getJson('/api/v1/groups');
  }

  static fetchCurrentDevices() {
    return ApiClient.getJson('/api/v1/users/devices');
  }

  static fetchDeviceMetadataByDeviceId(deviceId) {
    return ApiClient.getJson(`/api/v1/devices/${deviceId}/metadata`);
  }

  static fetchUserOmniauthProviders() {
    return ApiClient.getJson('/api/v1/users/omniauth_providers');
  }

  static addMembers(groupId, userIds) {
    return ApiClient.postJson(`/api/v1/groups/${groupId}/members`, { body: { user_ids: userIds } });
  }

  static removeMember(groupId, userId) {
    return ApiClient.deleteRequest(`/api/v1/groups/${groupId}/members/${userId}`);
  }

  static promoteAdmin(groupId, userId) {
    return ApiClient.postJson(`/api/v1/groups/${groupId}/admins/${userId}`);
  }

  static demoteAdmin(groupId, userId) {
    return ApiClient.deleteRequest(`/api/v1/groups/${groupId}/admins/${userId}`);
  }

  static destroyGroup(groupId) {
    return ApiClient.deleteRequest(`/api/v1/groups/${groupId}`);
  }

  static fetchOls(name, edited = true) {
    return ApiClient.getJson(`/api/v1/ols_terms/list?name=${name}&edited=${edited}`);
  }

  static listEditors() {
    return ApiClient.getJson('/api/v1/users/list_editors');
  }

  static updateUserCounter(params = {}) {
    return ApiClient.putJson('/api/v1/users/update_counter', { body: params });
  }

  static scifinderCredential() {
    return ApiClient.getJson('/api/v1/users/scifinder');
  }

  static fetchUserKetcherOptions() {
    return ApiClient.getJson('/api/v1/profiles/editors/ketcher-options');
  }

  static updateUserKetcherOptions(list) {
    const data = JSON.parse(list);
    return ApiClient.putJson('/api/v1/profiles/editors/ketcher-options', { body: data });
  }

  static updateReactionShortLabel(params) {
    return ApiClient.putJson('/api/v1/users/reaction_short_label', { body: params });
  }

  static fetch2FAQR() {
    return ApiClient.getJson('/api/v1/users/two_factor');
  }

  static fetchEnable2FAQR() {
    return ApiClient.putJson('/api/v1/users/two_factor');
  }

  static logoutUser() {
    return ApiClient.deleteRequest('/users/sign_out', {
      body: { authenticity_token: DocumentHelper.getMetaContent('csrf-token') },
      headers: {},
    });
  }

  static submitAsForm(url, method, body) {
    body.append('authenticity_token', DocumentHelper.getMetaContent('csrf-token'));
    const options = {
      body,
      headers: {},
      handleResponseSuccess: (response) => response
    };
    if (method === 'PUT') {
      return ApiClient.putFormData(url, options);
    }
    return ApiClient.postFormData(url, options);
  }

  static fetchRevokeAuthTokens(params) {
    return ApiClient.postJson('/api/v1/users/revoke_auth_token', {
      body: params,
      handleResponseSuccess: (response) => {
        if (!response.ok) {
          throw new ResponseError(response);
        }
        return response.json();
      },
      handleResponseError: (exception) => {
        console.error('Fetch error in users/revoke_auth_token:', exception);
        throw exception;
      }
    });
  }

  static fetchNewAuthToken(params) {
    return ApiClient.postJson('/api/v1/users/auth_token', {
      body: params,
      handleResponseSuccess: (response) => {
        if (!response.ok) {
          throw new ResponseError(response);
        }
        return response.json();
      },
      handleResponseError: (exception) => {
        console.error('Fetch error in public/token:', exception);
        throw exception;
      }
    });
  }
}
